import $ from 'jquery';

$(function() {
    var modal = $(".modal");
    modal.on('shown.bs.modal', function(){
        $('html').css({ 'overflow-y': "hidden" });
      }).on('hidden.bs.modal', function(){
        $('html').css({ 'overflow-y': "scroll" });
      });
            
});




// WEBPACK FOOTER //
// ./components/cwm-modal/scripts/cwm-modal.js